export class Task {
  constructor(
    public id: number,
    public ticketId: number,
    public title: string,
    public remark: string,
    public status: number,
    public task_type: number,
    public end_date: Date,
    public details: string,
    public executor: string,
    public executorId: number
  ) {}

  public static get EMPTY(): Task {
    return new Task(0, 0, "", "", 0, 0, new Date(), "", "", 0);
  }

  hasValidValue(): boolean {
    return !!this.title && this.title.trim().length > 0;
  }
}
